module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.issue.volume) ? _c('div', [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-current-issue'), _vm._v(" "), _c('sidebar-signup-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "row issue-number hidden-sm-down"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h2', [_vm._v("Volume " + _vm._s(_vm.issue.volume) + ", Number " + _vm._s(_vm.issue.issue))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Pages: " + _vm._s(_vm.issue.pages.start) + " - " + _vm._s(_vm.issue.pages.end))])]), _vm._v(" "), _c('div', {
    staticClass: "left-column hidden-sm-down",
    attrs: {
      "id": "issueAnchors"
    }
  }, [_c('img', {
    staticClass: "mb-2",
    attrs: {
      "width": "170",
      "src": _vm.issue.optimized_urls.small
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.issue.rubricLinks), function(link) {
    return _c('a', {
      key: link.url,
      staticClass: "link",
      class: {
        'active': _vm.currentSection === link.id
      },
      attrs: {
        "href": link.url
      }
    }, [_vm._v("\n        " + _vm._s(link.text)), _c('i', {
      staticClass: "icon icon-color-arrow-right"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "right-column"
  }, [(_vm.topArticle.ids) ? _c('full-issue', {
    attrs: {
      "issue": _vm.topArticle
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.issue.rubricLinks), function(group) {
    return _c('title-block', {
      key: group.id,
      attrs: {
        "title": group.text,
        "id": group.id,
        "color-theme": "primary-color"
      }
    }, [_c('div', _vm._l((_vm.issue.articles), function(article, index) {
      return (article.article_type.name == group.text) ? _c('condensed-issue', {
        key: article.ids.pii,
        attrs: {
          "issue": article,
          "smallMode": index > 0 && article.article_type.name === _vm.issue.articles[index - 1].article_type.name ? true : false,
          "hideType": true
        }
      }) : _vm._e()
    }))])
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('title-block', {
    attrs: {
      "title": "Impact Factor / Index / Archive:"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('sidebar-sponsorship')], 1)], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2083772a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/IssueDetailPage.vue
// module id = 1400
// module chunks = 1